export const initialViewState = {
  // longitude: 39.9544627279009,
  // latitude: 43.4065616182625,
  zoom: 3,
  longitude: 37.504063,
  latitude: 55.730588,
};
